import { getCurrentTime } from "sb-resp-utils";
import { TypeExtends } from "sb-js-extends";
TypeExtends();
export class AggregatedEventGeneralDataParser {
    static parse(aggregatedEvent, currentTimeZone, timeFormat) {
        let eventIdsCount = (aggregatedEvent.metadata && aggregatedEvent.metadata.aggregatedEventIds && aggregatedEvent.metadata.aggregatedEventIds.split(";").length) || "";
        let startEventDate = new Date(aggregatedEvent.startEventDate);
        let getEventTime = new Date(startEventDate).getTime() + new Date(startEventDate).getTimezoneOffset() * 60 * 1000;
        let adjustedDate = getCurrentTime(new Date(getEventTime), currentTimeZone).formatDate(timeFormat);
        return {
            name: aggregatedEvent.eventName,
            count: `${eventIdsCount}`,
            startingTime: adjustedDate,
        };
    }
}
//# sourceMappingURL=AggregatedEventGeneralDataParser.js.map